import { render, staticRenderFns } from "./Benefits.vue?vue&type=template&id=ca1ea8ca&scoped=true"
import script from "./Benefits.vue?vue&type=script&lang=js"
export * from "./Benefits.vue?vue&type=script&lang=js"
import style0 from "./Benefits.vue?vue&type=style&index=0&id=ca1ea8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1ea8ca",
  null
  
)

export default component.exports